export default __webpack_public_path__ + "static/media/VD3.9e027c97.png";